import { render, staticRenderFns } from "./EmailMessagePrivateNote.vue?vue&type=template&id=28a1a68a&scoped=true&"
import script from "./EmailMessagePrivateNote.vue?vue&type=script&lang=js&"
export * from "./EmailMessagePrivateNote.vue?vue&type=script&lang=js&"
import style0 from "./EmailMessagePrivateNote.vue?vue&type=style&index=0&id=28a1a68a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a1a68a",
  null
  
)

export default component.exports